/**
 * Renders the invisible SVG symbol bundle once per page.
 *
 * Legacy consumers can still reference `#logo-dark`/`#logo-wordmark`, but the
 * core mark source remains StreamLainLogoMark.
 */
import type { FC } from 'react';

import { STREAMLAIN_CORE_LOGO } from './streamlain-logo-mark';
import { StreamLainLogoMark } from './StreamLainLogoMark';
import { StreamLainWordmark } from './StreamLainWordmark';

export const BrandLogoDefs: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0"
    height="0"
    style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
    aria-hidden
    focusable={false}
  >
    <defs>
      <symbol id="logo-dark" viewBox={STREAMLAIN_CORE_LOGO.mark.viewBox}>
        <StreamLainLogoMark idsPrefix="sl-logo-dark" />
      </symbol>

      <symbol
        id="logo-wordmark"
        viewBox={STREAMLAIN_CORE_LOGO.wordmark.viewBox}
      >
        <StreamLainWordmark idsPrefix="sl-logo-wordmark" />
      </symbol>
    </defs>
  </svg>
);
